import Map from '../components/map.svelte';
// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { CSSPlugin } from 'gsap/CSSPlugin'
// gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(CSSPlugin)

const { $ } = window;
const $body = $( document.body );

const prevArrow =
  '<button type="button" class="slick-prev"><svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z" fill="#006FAA"/> <path d="M21.5901 39L36.7001 56.04H49.8301L34.7201 39L49.8301 21.96H36.7001L21.5901 39Z" fill="white"/> </svg> <span class="sr-only">Previous</span></button>';
const nextArrow =
  '<button type="button" class="slick-next"><svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M39 4.21991e-06C17.4609 2.3369e-06 5.2925e-06 17.4609 3.40949e-06 39C1.52648e-06 60.5391 17.4609 78 39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 6.10291e-06 39 4.21991e-06Z" fill="#006FAA"/> <path d="M56.41 39L41.3 21.96L28.17 21.96L43.28 39L28.17 56.04L41.3 56.04L56.41 39Z" fill="white"/> </svg> <span class="sr-only">Next</span></button>';

function recalc() {
		let navHeight = $( '.navbar' ).outerHeight();
		console.log(navHeight);
		if(document.body.classList.contains('logged-in')) {
			navHeight += 32;
		}

		document
			.querySelector( ':root' )
			.style.setProperty( '--navbar-height', navHeight - 3 + 'px' );
	
		const mmHeaderHeight = document.querySelector( '.mobile-menu-header' ).clientHeight;
		document
			.querySelector( ':root' )
			.style.setProperty( '--mobile-menu-header', mmHeaderHeight + 'px' );
}

function responsiveNavbar() {
	// window.onload = () => {
	// 	setTimeout(() => {
	// 		recalc();
	// 	}, 200)
	// }
	// window.addEventListener('resize', recalc)
}

function mobileMenu() {
	const $menu = $( '#mobile-menu' );
	if(!$menu.length) return;
	const $btn = $( '#toggle_nav' );
	const $closeBtn = $( '.mobile-menu-close' );

	$menu.hide();
	$( '#mobile-menu .menu-item.menu-item-has-children .sub-menu' ).hide();
	$menu.removeClass( 'loading' );

	//open
	$btn.on( 'click', function( ) {
		$body.toggleClass( 'mm-open' );
		$menu.fadeToggle();

		// setTimeout( function() {
		const mmHeaderHeight = document.querySelector( '.mobile-menu-header' ).clientHeight;
		document
			.querySelector( ':root' )
			.style.setProperty( '--mobile-menu-header', mmHeaderHeight + 'px' );
	} );
	//close
	$closeBtn.on( 'click', function( ) {
		$body.toggleClass( 'mm-open' );
		$menu.fadeToggle();
	} );

	$( '#mobile-menu .menu-item:not(.menu-item-has-children)' ).on( 'click', function( ) {
		$body.toggleClass( 'mm-open' );
		$menu.fadeToggle();
	} );
	$( '#mobile-menu .menu-item.menu-item-has-children' ).on( 'click', function( ) {
		$( this ).find( '.sub-menu' ).slideToggle( 200 );
	} );

	function closeOnDesktop( x ) {
		if ( x.matches ) {
			$menu.fadeOut();
			$body.removeClass( 'mm-open' );
		}
	}

	const x = window.matchMedia( '(min-width: 1025px)' ); //match
	closeOnDesktop( x );
	x.addListener( closeOnDesktop );
}

function stickyHeader() {
	const wrap = document.querySelector( '.navbar-wrap' );
	const navbar = document.querySelector( '.navbar' );
	const navbarPos = navbar.getBoundingClientRect().top + window.pageYOffset;

	function handleNavbarPageYOffset( ) {
		let offset = window.pageYOffset;
		if ( ! offset ) {
			offset = 0;
		}
		navbarPos + 100 < offset
			? wrap.classList.add( 'issticky' )
			: wrap.classList.remove( 'issticky' );
	}

	$( window ).on( 'scroll', handleNavbarPageYOffset );
	handleNavbarPageYOffset(); //page refresh handle
}

function footerMobileMenu() {
	function toggleFooterSubMenu( e ) {
		e.preventDefault();
		$( this ).parent().find( '.sub-menu' ).slideToggle();
	}

	function adjustFooterMenu( x ) {
		if ( x.matches ) { // If media query matches
			$( '.footer-navigation .menu-item-has-children .sub-menu' ).hide();
			$( '.footer-navigation .menu-item-has-children > a' ).on( 'click', toggleFooterSubMenu );
		} else {
			$( '.footer-navigation .menu-item-has-children > a' ).off( 'click', toggleFooterSubMenu );
			$( '.footer-navigation .menu-item-has-children .sub-menu' ).show();
		}
	}

	const x = window.matchMedia( '(max-width: 1023px)' );
	adjustFooterMenu( x );
	x.addListener( adjustFooterMenu );
}

function handleMap( el ) {
	// const $mapAnchor = $( '#map-locations-wrap' );
	// if ( ! $mapAnchor.length ) {
	// 	return;
	// }

	new Map( {
		target: el,
		props: $( el ).data(),
	} );
}

function closeNavbarToast() {
	const $navarToast = $( '.navbar-toast' );
	if ( ! $navarToast.length ) {
		return;
	}
	const $toastClose = $navarToast.find( '.toast-close' ); //assumes exists
	$toastClose.on( 'click', function() {
		$toastClose.fadeOut( 20 );
		setTimeout( () => {
			$navarToast.fadeTo(400, 0).slideUp(250)
			setTimeout( () => {
				recalc()
			}, 420 );
		}, 20 );
	} );
}

function runFunctions() {
	responsiveNavbar();
	mobileMenu();
	stickyHeader();
	footerMobileMenu();
	closeNavbarToast();
}

export {
	prevArrow,
	nextArrow,
	handleMap,
	runFunctions,
};
